import React from "react";
import { iconProps } from "../../Helper";

const EditPinWithBackgroundIcon = ({className}:iconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
      className={className}
        d="M1.98081 14.3748C1.60194 14.3748 1.28125 14.2435 1.01875 13.981C0.75625 13.7185 0.625 13.3978 0.625 13.019V2.98059C0.625 2.60171 0.75625 2.28102 1.01875 2.01852C1.28125 1.75602 1.60194 1.62477 1.98081 1.62477H8.47262L7.34762 2.74977H1.98081C1.92306 2.74977 1.87019 2.77383 1.82219 2.82196C1.77406 2.86996 1.75 2.92284 1.75 2.98059V13.019C1.75 13.0767 1.77406 13.1296 1.82219 13.1776C1.87019 13.2257 1.92306 13.2498 1.98081 13.2498H12.0192C12.0769 13.2498 12.1298 13.2257 12.1778 13.1776C12.2259 13.1296 12.25 13.0767 12.25 13.019V7.60452L13.375 6.47952V13.019C13.375 13.3978 13.2438 13.7185 12.9813 13.981C12.7188 14.2435 12.3981 14.3748 12.0192 14.3748H1.98081ZM5.125 9.87477V7.30021L11.9198 0.505585C12.0361 0.38921 12.1639 0.304335 12.3034 0.25096C12.4428 0.197585 12.5846 0.170898 12.7289 0.170898C12.876 0.170898 13.0173 0.197585 13.1528 0.25096C13.2884 0.304335 13.412 0.386773 13.5235 0.498273L14.4653 1.43727C14.5739 1.55365 14.6574 1.68202 14.7156 1.8224C14.7738 1.96277 14.8028 2.10509 14.8028 2.24934C14.8028 2.39359 14.7781 2.53346 14.7286 2.66896C14.6791 2.80459 14.5961 2.93052 14.4797 3.04677L7.66338 9.87477H5.125ZM6.25 8.74977H7.18469L11.8591 4.07521L11.3918 3.60796L10.8914 3.12627L6.25 7.76765V8.74977Z"
        fill="white"
      />
    </svg>
  );
};

export default EditPinWithBackgroundIcon;
